<template>
  <card dis-hover :padding="8" class="feedback-add">
    <div class="feedback-add__title ms-help">Добавление новой задачи</div>
    <div class="feedback-add__block">
      <i-input placeholder="Описание задачи" type="textarea" v-model="text" />
    </div>
    <div class="feedback-add__block">
      <i-select
        clearable
        filterable
        v-model="performer_id"
        placeholder="Выберите исполнителя"
      >
        <i-option
          v-for="user in users"
          :key="user.id"
          :value="user.id"
          :label="getUserLabel(user)"
        />
      </i-select>
    </div>
    <div class="feedback-add__block">
      <i-button
        :loading="loading"
        :disabled="disabled"
        type="success"
        @click="add"
        long
        size="default"
      >
        Добавить
      </i-button>
    </div>
  </card>
</template>

<script>
export default {
  props: {
    contract_id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      text: '',
      performer_id: null
    }
  },
  computed: {
    users () {
      return [...this.$store.state.users].sort((a, b) => {
        const aName = a.last_name ? a.last_name.toLowerCase() : ''
        const bName = b.last_name ? b.last_name.toLowerCase() : ''

        if (aName > bName) return 1
        if (aName < bName) return -1
        return 0
      })
    },
    disabled () {
      return !this.text || !this.performer_id
    }
  },
  methods: {
    getData () {
      return {
        text: this.text,
        performer_id: this.performer_id,
        contract_id: this.contract_id
      }
    },
    clearData () {
      this.text = ''
      this.performer_id = null
    },
    async add () {
      try {
        this.loading = true

        const url = `page/task`
        const data = this.getData()

        await this.$store.dispatch('POST_REQUEST', { url, data })

        this.clearData()

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    getUserLabel ({ username, first_name, last_name }) {
      if (first_name && last_name) {
        return `${last_name} ${first_name}`
      }

      return username
    }
  }
}
</script>

<style lang="less">
.feedback-add {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  &__block {
    margin-top: 8px;
  }
}
</style>
